import React, { Component } from "react";
import { withDataAnalyse } from "../../../../shared/containers/containerDataAnalyse";
import Scrollbars from "react-custom-scrollbars-2";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";

class DataAnalyseTable extends Component {
  getHaders() {
    const { headers } = this.props;

    return headers.map((x, index) => {
      return (
        <div key={index}>
          <div style={{ padding: "3px", width: "125px" }}>
            <b>{x}</b>
          </div>
        </div>
      );
    });
  }

  getRows() {
    const { headers, simpleSignals } = this.props;

    return simpleSignals.map((simpleSignal, rowKey) => {
      return (
        <div key={rowKey} style={{ display: "flex" }}>
          {headers.map((key, index) => {
            if (!simpleSignal.data[key]) {
              return (
                <div key={index}>
                  <div style={{ padding: "3px", width: "125px" }}>
                    <div> </div>
                    <div> </div>
                  </div>
                </div>
              );
            }

            return (
              <div key={index}>
                <TooltipWrapper title={`${key}: ${simpleSignal.data["TI"].origenal}`} position="top">
                  <div style={{ padding: "3px", width: "125px", borderBottom: "1px solid" }}>
                    <div>{simpleSignal.data[key].origenal !== "" ? simpleSignal.data[key].origenal : "_"}</div>
                    <div>{simpleSignal.data[key].value !== "" ? simpleSignal.data[key].value : "_"}</div>
                  </div>
                </TooltipWrapper>
              </div>
            );
          })}
        </div>
      );
    });
  }

  render() {
    return (
      <Scrollbars ref="scrollbar" style={{ height: "330px" }} autoHide={false} autoHeightMax={50}>
        <div style={{ display: "flex" }}>{this.getHaders()}</div>
        <div>{this.getRows()}</div>
      </Scrollbars>
    );
  }
}

export default withDataAnalyse(DataAnalyseTable);
